/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_Disabled_ToastInputs */

const en_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External device control disabled`)
};

const fr_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle d'appareil externe desactive`)
};

const de_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Gerätesteuerung deaktiviert`)
};

const it_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo dispositivo esterno disabilitato`)
};

const ru_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление внешним устройством отключено`)
};

const es_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de dispositivo externo deshabilitado`)
};

const zh_cn2_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部设备控制已禁用`)
};

const ja_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外部デバイス制御が無効`)
};

const hi_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाह्य उपकरण नियंत्रण अक्षम`)
};

const pt_pt2_creator_ext_device_disabled_toast = /** @type {(inputs: Creator_Ext_Device_Disabled_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de dispositivo externo desativado`)
};

/**
* | output |
* | --- |
* | "External device control disabled" |
*
* @param {Creator_Ext_Device_Disabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_disabled_toast = /** @type {((inputs?: Creator_Ext_Device_Disabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_Disabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_ext_device_disabled_toast(inputs)
	if (locale === "de") return de_creator_ext_device_disabled_toast(inputs)
	if (locale === "it") return it_creator_ext_device_disabled_toast(inputs)
	if (locale === "ru") return ru_creator_ext_device_disabled_toast(inputs)
	if (locale === "es") return es_creator_ext_device_disabled_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_ext_device_disabled_toast(inputs)
	if (locale === "ja") return ja_creator_ext_device_disabled_toast(inputs)
	if (locale === "hi") return hi_creator_ext_device_disabled_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_ext_device_disabled_toast(inputs)
	return en_creator_ext_device_disabled_toast(inputs)
});